import React from 'react'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

const Link = ({ url, name }) => {
  if (url) {
    return (
      <OutboundLink
        href={url}
        target="_blank"
        className="mr-6 text-black text-sm"
        rel="noopener noreferrer"
      >
        {name}
      </OutboundLink>
    )
  } else {
    return ''
  }
}

class Profile extends React.Component {
  render() {
    const profile = this.props.data
    var image = profile.Headshot[0].url
    var id = this.props.id
    var location = '#' + id
    var path =
      '/hire/' +
      profile.Name.trim()
        .replace(/\s+/g, '-')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/'/g, '')
        .toLowerCase()

    return (
      //new one
      <div className="flex flex-col  overflow-hidden border rounded bg-white p-6">
        <div className="flex">
          <div>
            <h3 className="text-lg leading-7 font-semibold text-gray-900">
              <a href={path}>{profile.Name}</a>{' '}
              <span
                className={
                  'text-sm text-gray-600 ' + (profile.Pronoun ? '' : ' hidden')
                }
              >
                ({profile.Pronoun})
              </span>
            </h3>
            <div className="flex text-md leading-5 font-medium text-gray-800">
              <span>{profile.Role}</span>
            </div>
            <div className="flex text-sm leading-5 text-gray-600">
              <span>{profile.Location}</span>
            </div>
          </div>
        </div>

        <div className="flex-1 bg-white flex flex-col justify-between">
          <div className="flex-1">
            <p className="text-sm leading-5 text-gray-800 pt-4 overflow-auto h-48">
              {profile.Short_Intro}
            </p>
          </div>

          <div className="links flex flex-wrap leading-10 text-gray-700 text-center">
            <Link url={profile.Website} name="Website" />
            {/* <Link url={profile.Github} name="Github" /> */}
            <Link url={profile.Twitter_Profile} name="Twitter" />
            <Link url={profile.LinkedIn_Page} name="LinkedIn" />
            {/* <a
              href={'mailto:' + profile.Email}
              target="_top"
              className="text-black text-sm"
            >
              Email
            </a> */}
          </div>
        </div>
      </div>
    )
  }
}

export default Profile
